export const PROFILES_LOCALIZATION_SCOPE = 'profiles';
